import React from 'react';

interface GemIconProps {
  color?: 'red' | 'gray';
  size?: number;
}

const GemIcon: React.FC<GemIconProps> = ({ color = 'red', size = 24 }) => {
  const fillColor = color === 'red' ? '#dc3545' : '#6c757d';
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flexShrink: 0,
        display: 'block'
      }}
    >
      <path
        d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z"
        stroke="#000"
        strokeWidth="1.5"
        fill={fillColor}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GemIcon;
